import React, { useRef } from 'react';
import './ToneSections.css';

interface BrandToneSectionProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  teamId?: string;
}

const BrandToneSection: React.FC<BrandToneSectionProps> = ({ 
  value, 
  onChange, 
  disabled,
  teamId 
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const handleBlur = () => {
    if (contentRef.current) {
      onChange(contentRef.current.innerText);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      e.preventDefault();
      if (contentRef.current) {
        contentRef.current.blur();
      }
    }
  };

  return (
    <div className="tone-section-item">
      <div className="tone-section-header">
        <div className="tone-section-title">Brand Tone</div>
        <div className="tone-section-description">Define how your brand should sound to customers.</div>
      </div>

      <div className="tone-section-content">
        <div
          ref={contentRef}
          className={`tone-content-editable ${!value && 'empty'}`}
          contentEditable={!disabled}
          suppressContentEditableWarning={true}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          data-placeholder="Describe your brand tone and voice..."
          dangerouslySetInnerHTML={{ __html: value }}
        />
      </div>
    </div>
  );
};

export default BrandToneSection; 